<template>
    <div >

        <div class="TQ_borderRadius TQ_inline "
             v-for="(shareBtn_o,index ) in co_shareBtnData_o"
             :key="index">

            <div v-if="!pf_smallMode_b" class="TQ_direction_ltr TQ_border TQ_bg_white TQ_margin_8px">

                <div class="shareBtnLeft TQ_inline TQ_width_150px TQ_padding_8px TQ_align_initial TQ_textColor_white"
                     :style="{'background' : shareBtn_o.background_s}" @click.stop="shareBtn_o.action_f">
                    <div class="TQ_padding_4px TQ_inline"></div> <!-- space -->
                    <img :src="shareBtn_o.img_r" class="TQ_width_24px TQ_verticalAlignMiddle"/>
                    <div class="TQ_padding_8px TQ_inline"></div> <!-- space -->
                    <div class="TQ_inline TQ_verticalAlignMiddle TQ_width_44px">{{shareBtn_o.text_s}}</div>
                </div>
                <div class="shareBtnRight TQ_inline TQ_padding_8px TQ_width_24px TQ_center"> {{shareBtn_o.shareNum_n}} </div>

            </div>

            <div v-else class="TQ_inline TQ_borderRadius TQ_textColor_white TQ_margin_4px TQ_box_shadow TQ_clickable"
                 :style="{'background' : shareBtn_o.background_s}" @click.stop="shareBtn_o.action_f">
                <img :src="shareBtn_o.img_r" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_8px"/>
            </div>

        </div>

    </div>
</template>

<script>
    import {
        ass_img_facebook_w,
        ass_img_google_w,
        ass_img_mail_w,
        ass_img_twitter_w,
        ass_img_whatsapp_w
    } from "../../assets/scripts/Ass_Files";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {enum_colors, enum_moveToOptions} from "../../../functions/src/shareCode/Share_S_Enum";
    import {gv_urls, gv_strings} from "../../scripts/S_GlobalVar";
    import {facebook_share} from "../../scripts/API/S_API_Facebook";
    import {route_addLangToPath_s, route_openNewWindow_f, route_windowReplace_f} from "../../router";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {FB_QuestExplore} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_langCodes, enum_shareOptions} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "TqSharesButtons",
        props:{
            pb_questId_uid:{
                type: String,
                require: true,
            },
            ps_langCode_e :{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            pf_smallMode_b:{
                type: Boolean,
                default : false
            }
        },
        computed : {
            co_shareBtnData_o(){
                return [
                    {background_s: enum_colors.blue,        img_r: ass_img_facebook_w,  action_f : () => {this.m_clickShare_f(enum_shareOptions.facebook)},  text_s: ass_strings.oneWord_facebook[this.p_system_langCode_e],    },
                    {background_s: enum_colors.blue_lite,   img_r: ass_img_twitter_w,   action_f : () => {this.m_clickShare_f(enum_shareOptions.twitter)},   text_s: ass_strings.oneWord_twitter[this.p_system_langCode_e],     },
                    {background_s: enum_colors.green,       img_r: ass_img_whatsapp_w,  action_f : () => {this.m_clickShare_f(enum_shareOptions.whatsapp)},  text_s: ass_strings.oneWord_whatsapp[this.p_system_langCode_e],    },
                    {background_s: enum_colors.red,         img_r: ass_img_google_w,      action_f : () => {this.m_clickShare_f(enum_shareOptions.gmail)},     text_s: ass_strings.oneWord_google[this.p_system_langCode_e],       },
                    {background_s: enum_colors.gray1,       img_r: ass_img_mail_w,      action_f : () => {this.m_clickShare_f(enum_shareOptions.email)},     text_s: ass_strings.oneWord_email[this.p_system_langCode_e],       },
                ]
            },
        },
        methods:{
            m_clickShare_f(sharePlatform_e){


                let sharedText_s =`${gv_urls.tq_basicUrl}${route_addLangToPath_s(enum_moveToOptions.player_store_quest)}/${this.pb_questId_uid}`

                switch(sharePlatform_e){
                    case enum_shareOptions.facebook:
                        facebook_share(sharedText_s, (res) => {})
                        break;

                    case enum_shareOptions.email:
                        route_windowReplace_f(gv_urls.email_share_prefix + sharedText_s)
                        break;

                    case enum_shareOptions.gmail:
                        route_openNewWindow_f(gv_urls.gmail_share_prefix + sharedText_s, enum_shareOptions.whatsapp)
                        break;

                    case enum_shareOptions.twitter:
                        route_openNewWindow_f(gv_urls.twitter_share_prefix + sharedText_s, enum_shareOptions.whatsapp)
                        break;

                    case enum_shareOptions.whatsapp:
                        route_openNewWindow_f(gv_urls.whatsApp_share_prefix + sharedText_s, enum_shareOptions.whatsapp)
                        break;
                }

            },

        }
    }
</script>

<style scoped lang="scss">
    /* share btn */
    .shareBtnLeft{
        border-radius: 4px 0px 0px 4px;
    }

    .shareBtnRight{
        border-radius: 4px 0px 0px 4px;
        position: relative;
    }

    .shareBtnRight:after {
        content: '';
        display: block;
        position: absolute;
        background: white;
        top: 12px;
        left: -5px;
        width: 10px;
        height: 10px;
        -moz-transform:rotate(45deg);
        -webkit-transform:rotate(45deg);
    }
</style>